/**
 * Roleta WHATS — camada de markup.
 *
 * Mixin aplicado no protótipo de RoletaWhats (roleta.js). Só monta HTML:
 * reaproveita as classes do meno-aliv-wheel.css (.form-group, .input,
 * .error-text, .cta-btn…) para o card ficar idêntico ao modal original.
 */
window.RoletaWhatsView = {
  // escapeHtml da base não escapa aspas — necessário dentro de atributos
  escapeAttr(str) {
    return this.escapeHtml(str).replace(/"/g, '&quot;');
  },

  emailFieldMarkup() {
    const err = this.state.emailError;
    return `
      <div class="form-group">
        <label class="label" for="email-input">${this.escapeHtml(this.config.emailLabel)}</label>
        <input type="email" id="email-input" class="input${err ? ' error' : ''}"
          placeholder="${this.escapeAttr(this.config.emailPlaceholder)}"
          value="${this.escapeAttr(this.state.email)}" autocomplete="email"
          inputmode="email" aria-invalid="${!!err}"
          ${err ? 'aria-describedby="email-input-error"' : ''} />
        ${err ? this.emailErrorMarkup(err) : ''}
      </div>
    `;
  },

  emailErrorMarkup(message) {
    return `<p id="email-input-error" class="error-text" role="alert" aria-live="polite">${this.escapeHtml(message)}</p>`;
  },

  prizeMarkup() {
    const prize = this.state.prize || {};
    const headline = this.state.isLastResultRecall
      ? 'Este foi o seu prêmio:'
      : 'Parabéns! Você acaba de ganhar:';
    const desc = prize.description
      ? `<p class="prize-description">🎁 ${this.escapeHtml(prize.description)}</p>`
      : '';
    return `<h2 class="congrats">${headline}</h2>
        <div class="prize-badge">${this.escapeHtml(prize.label || '')}</div>${desc}`;
  },

  whatsCtaMarkup() {
    const SVG = window.MenoAlivWheel.SVG;
    return `<a class="cta-btn" href="${this.escapeAttr(this.config.whatsappUrl || '#')}" rel="noopener">
          ${SVG.spin()} ${this.escapeHtml(this.config.ctaLabel)}
        </a>`;
  },

  renderResultStep() {
    const SVG = window.MenoAlivWheel.SVG;
    return `
      <div class="result-container">
        ${this.prizeMarkup()}
        <p class="subtitle">${this.escapeHtml(this.config.resultNote)}</p>
        ${this.whatsCtaMarkup()}
        <div class="social-proof" style="margin-top: 24px;">
          ${SVG.star()} ${this.escapeHtml(this.config.couponNote)}
        </div>
      </div>
      <div class="confetti-container"></div>
    `;
  }
};
